/** Dispatched on `window` when her muses have changed under the strip (the intake queued one): the strip reads the roster again. */
export const MUSES_CHANGED_EVENT = 'ovid:muses-changed'

export function announceMusesChanged(): void {
    window.dispatchEvent(new Event(MUSES_CHANGED_EVENT))
}
